export const SUCCESS_RES = 'OK';
